'use client';

import {
  useGetCurrentDpaQuery,
  useGetCurrentPrivacyQuery,
  useGetCurrentTermsQuery,
} from '@/features/legal/api/legalApi';

import { PublicLegalDocumentPage } from './PublicLegalDocumentPage';

function getMarkdownContent(data: unknown): string | null {
  if (!data || typeof data !== 'object') {
    return null;
  }

  if (!('content_markdown' in data)) {
    return null;
  }

  const content = data.content_markdown;
  return typeof content === 'string' ? content : null;
}

export function PublicTermsPageClient() {
  const { data, isFetching, isLoading, isError } = useGetCurrentTermsQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    },
  );

  return (
    <PublicLegalDocumentPage
      title="Terms & Conditions"
      description="The latest active Net Net terms and conditions."
      markdownContent={getMarkdownContent(data?.data)}
      isLoading={isLoading || isFetching}
      isError={isError}
    />
  );
}

export function PublicPrivacyPageClient() {
  const { data, isFetching, isLoading, isError } = useGetCurrentPrivacyQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    },
  );

  return (
    <PublicLegalDocumentPage
      title="Privacy Policy"
      description="The latest active Net Net privacy policy."
      markdownContent={getMarkdownContent(data?.data)}
      isLoading={isLoading || isFetching}
      isError={isError}
    />
  );
}

export function PublicDpaPageClient() {
  const { data, isFetching, isLoading, isError } = useGetCurrentDpaQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    },
  );

  return (
    <PublicLegalDocumentPage
      title="Data Processing Addendum"
      description="The latest active Net Net data processing addendum."
      markdownContent={getMarkdownContent(data?.data)}
      isLoading={isLoading || isFetching}
      isError={isError}
    />
  );
}
